import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class BaocaoService {

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8'
    })
  };
  urlRpCsgd = environment.apiUrl + environment.ver + '/RpCsgd';
  urlCsgdTksl = environment.apiUrl + environment.ver + '/RpCsgdTksl';
  urlCsgdThcb = environment.apiUrl + environment.ver + '/RpCsgdThcb';
  urlRpCsgdThttnkt = environment.apiUrl + environment.ver + '/RpCsgdThttnkt';
  urlRpCsgdTknkt = environment.apiUrl + environment.ver + '/RpCsgdTknkt';
  urlRpStudentSurvey = environment.apiUrl + environment.ver + '/RpStudentSurvey';
  urlRpStudentProvince = environment.apiUrl + environment.ver + '/RpBcTtNkt';
  /* 1. Bao cao ve co so giao duc */
  urlRpCsgdThttCsgd = environment.apiUrl + environment.ver + '/RpCsgdThttCsgd';
  urlRpCsgdTkcsgdCtt = environment.apiUrl + environment.ver + '/RpCsgdTkcsgdCtt';
  urlRpCsgdTkcsvcGddb = environment.apiUrl + environment.ver + '/RpCsgdTkcsvcGddb';
  /*Bao cao ve nhan su*/
  urlNsTddt = environment.apiUrl + environment.ver + '/RpNsTddt';
  urlNsDtbdgddb = environment.apiUrl + environment.ver + '/RpNsDtbdgddb';
  urlNsTkslnstccsgd = environment.apiUrl + environment.ver + '/RpNsTkslnstccsgd';
  /**/
  urlRpNktTkttnkt = environment.apiUrl + environment.ver + '/RpNktTkttnkt';
  urlRpNktTkvgdnkt = environment.apiUrl + environment.ver + '/RpNktTkvgdnkt';
  urlBcttnkt = environment.apiUrl + environment.ver + '/RpBcttnktPhieu';
  urlBcttnnl = environment.apiUrl + environment.ver + '/RpBcnsTtnnl';
  urlBcTtCsgd = environment.apiUrl + environment.ver + '/RpBcTtCsgd';
  urlRpTkSlNktGcnTnt = environment.apiUrl + environment.ver + '/RpTkSlNktGcnTnt';
  urlRpStudentHtgd = environment.apiUrl + environment.ver + '/RpStudentHtgd';
  urlRpStudentTtct = environment.apiUrl + environment.ver + '/RpStudentTtct';
  urlRpStudentEducationalStatus = environment.apiUrl + environment.ver + '/RpStudentEducationalStatus';
  urlRpStudentTtvl = environment.apiUrl + environment.ver + '/RpStudentTtvl';
  urlRpStudentTthn = environment.apiUrl + environment.ver + '/RpStudentTthn';
  urlBcTDLTkGcnNkt = environment.apiUrl + environment.ver + '/BcTDLTkGcnNkt';
  urlBcStudentTDLEducationalStatus = environment.apiUrl + environment.ver + '/BcStudentTDLEducationalStatus';
  urlBcStudentHtgdTDL = environment.apiUrl + environment.ver + '/BcStudentHtgdTDL';
  urlBcStudentTtctTDL = environment.apiUrl + environment.ver + '/BcStudentTtctTDL';
  urlBcStudentTtvlTDL = environment.apiUrl + environment.ver + '/BcStudentTtvlTDL';
  urlBcStudentTthnTDL = environment.apiUrl + environment.ver + '/BcStudentTthnTDL';
  urlRpStudentDst = environment.apiUrl + environment.ver + '/RpStudentDst';
  urlBcStudentDkktTDL = environment.apiUrl + environment.ver + '/BcStudentDkktTDL';
  urlBcStudentDstTDL = environment.apiUrl + environment.ver + '/BcStudentDstTDL';
  urlRpStudentDkkt = environment.apiUrl + environment.ver + '/RpStudentDkkt';
  urlRpStudentTcvd = environment.apiUrl + environment.ver + '/RpStudentTcvd';
  urlRpStudentNt = environment.apiUrl + environment.ver + '/RpStudentNt';
  urlBcStudentTlntNkt = environment.apiUrl + environment.ver + '/BcStudentTlntNkt';
  urlBcStudentNngtNkt = environment.apiUrl + environment.ver + '/BcStudentNngtNkt';
  urlBcStudentTlTpvNkt = environment.apiUrl + environment.ver + '/BcStudentTlTpvNkt';
  urlBcStudentTlHvNkt = environment.apiUrl + environment.ver + '/BcStudentTlHvNkt';
  urlBcStudentTcvdTDL = environment.apiUrl + environment.ver + '/BcStudentTcvdTDL';
  urlBcStudentTlNcHtGdNkt = environment.apiUrl + environment.ver + '/BcStudentTlNcHtGdNkt';
  urlBcStudentTlCs = environment.apiUrl + environment.ver + '/BcStudentTlCs';
  urlBcStudentGcn = environment.apiUrl + environment.ver + '/BcStudentGcnNkt';
  urlSchoolADisasibility = environment.apiUrl + environment.ver + '/BcSchoolADisasibility';
  constructor(private http: HttpClient) {
  }

  GetReportCsgdInfo(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpCsgd + '/GetReportCsgdInfo?' + queryString);
  }
  exportExcelCsgdInfo(filter: any): Observable<any> {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpCsgd + '/GetReportCsgdInfoExport?' + queryString, { responseType: 'blob' as 'json' });
  }
  /* Start. thong ke co so giao duc - thong ke so luong .Start*/
  getRpCsgdTksl(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlCsgdTksl + '/Get?' + queryString);
  }
  exportRpCsgdTksl(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlCsgdTksl + '/Export?' + queryString, { responseType: 'blob' as 'json' });
  }
  /* End. thong ke co so giao duc - thong ke so luong .End*/

  /* Start. 6.2.2.	Thống kê CSGD theo cấp trực thuộc .Start*/
  getRpCsgdTkcsgdCtt(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpCsgdTkcsgdCtt + '/Get?' + queryString);
  }
  exportRpCsgdTkcsgdCtt(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpCsgdTkcsgdCtt + '/Export?' + queryString, { responseType: 'blob' as 'json' });
  }
  /* End. 6.2.2.	Thống kê CSGD theo cấp trực thuộc .End*/

  /* Start. 6.2.3.	Thống kê CSVC giáo dục đặc biệt .Start*/
  getRpCsgdTkcsvcGddb(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpCsgdTkcsvcGddb + '/Get?' + queryString);
  }
  exportRpCsgdTkcsvcGddb(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpCsgdTkcsvcGddb + '/Export?' + queryString, { responseType: 'blob' as 'json' });
  }
  /* End. 6.2.3.	Thống kê CSVC giáo dục đặc biệt .End*/

  /* Start. 6.2.4.	Tổng hợp thông tin CSGD .Start*/
  getRpCsgdThttCsgd(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpCsgdThttCsgd + '/Get?' + queryString);
  }
  exportRpCsgdThttCsgd(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpCsgdThttCsgd + '/Export?' + queryString, { responseType: 'blob' as 'json' });
  }
  /* End. 6.2.4.	Tổng hợp thông tin CSGD .End*/

  /* Start. 6.3.1. Báo cáo theo trình độ đào tạo .Start*/
  getRpNsTddt(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlNsTddt + '/Get?' + queryString);
  }
  exportRpNsTddt(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlNsTddt + '/Export?' + queryString, { responseType: 'blob' as 'json' });
  }
  /* End. 6.3.1. Báo cáo theo trình độ đào tạo .End*/

  /* Start. 6.3.2.	Báo cáo về đào tạo bồi dưỡng giáo dục đặc biệt .Start*/
  getRpNsDtbdgddb(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlNsDtbdgddb + '/Get?' + queryString);
  }
  exportRpNsDtbdgddb(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlNsDtbdgddb + '/Export?' + queryString, { responseType: 'blob' as 'json' });
  }
  /* End. 6.3.2.	Báo cáo về đào tạo bồi dưỡng giáo dục đặc biệt .End*/

  /* Start. 6.3.3.	Thống kê số lượng nhân sự tại các CSGD .Start*/
  getRpNsTkslnstccsgd(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlNsTkslnstccsgd + '/Get?' + queryString);
  }
  exportRpNsTkslnstccsgd(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlNsTkslnstccsgd + '/Export?' + queryString, { responseType: 'blob' as 'json' });
  }
  /* End. 6.3.3.	Thống kê số lượng nhân sự tại các CSGD .End*/

  /*=============START================ 6.4.	Báo cáo về người khuyết tật=================================*/
  /* Start.  6.4.1.	Thống kê thông tin người khuyết tật .Start*/
  getRpNktTkttnkt(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpNktTkttnkt + '/Get?' + queryString);
  }
  exportRpNktTkttnkt(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpNktTkttnkt + '/Export?' + queryString, { responseType: 'blob' as 'json' });
  }
  /* End.  6.4.1.	Thống kê thông tin người khuyết tật .End*/

  /* Start. 6.4.2.	Báo cáo thống kê về giáo dục người khuyết tật .Start*/
  getRpNktTkvgdnkt(filter: any): Observable<any> {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpNktTkvgdnkt + '/Get?' + queryString);
  }
  exportRpNktTkvgdnkt(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpNktTkvgdnkt + '/Export?' + queryString, { responseType: 'blob' as 'json' });
  }
  /* End. 6.4.2.	Báo cáo thống kê về giáo dục người khuyết tật .End*/
  /*=============END================ 6.4.	Báo cáo về người khuyết tật=================================*/
  getRpCsgdThcb(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlCsgdThcb + '/Get?' + queryString);
  }
  exportRpCsgdThcb(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlCsgdThcb + '/Export?' + queryString, { responseType: 'blob' as 'json' });
  }
  getRpCsgdThttnkt(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpCsgdThttnkt + '/Get?' + queryString);
  }
  getRpStudentSurvey(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpStudentSurvey + '/Get?' + queryString);
  }
  exportRpStudentSurvey(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpStudentSurvey + '/GetExport?' + queryString, { responseType: 'blob' as 'json' });
  }
  getRpStudentProvince(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpStudentProvince + '/Get?' + queryString);
  }

  exportRpStudentProvince(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpStudentProvince + '/GetExport?' + queryString, { responseType: 'blob' as 'json' });
  }
  exportRpCsgdThttnkt(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpCsgdThttnkt + '/Export?' + queryString, { responseType: 'blob' as 'json' });
  }
  getRpCsgdTknkt(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpCsgdTknkt + '/Get?' + queryString);
  }
  exportRpCsgdTknkt(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpCsgdTknkt + '/Export?' + queryString, { responseType: 'blob' as 'json' });
  }
   /* Báo cáo tổng hợp thông tin người khuyết tật - Phiếu .Start*/
   getRpttnkt(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcttnkt + '/Get?' + queryString);
  }
  exportRpttnkt(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcttnkt + '/GetExport?' + queryString, { responseType: 'blob' as 'json' });
  }
   /* Báo cáo thông tin nhân sự*/
   getRpttnnl(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcttnnl + '/Get?' + queryString);
  }
  exportRprrnnl(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcttnnl + '/GetExport?' + queryString, { responseType: 'blob' as 'json' });
  }

  /* Báo cáo thông tin cơ sở giáo dục*/
   getRpBcCsgd(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcTtCsgd + '/Get?' + queryString);
  }
  exportBcCsgd(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcTtCsgd + '/GetExport?' + queryString, { responseType: 'blob' as 'json' });
  }

  getRpTkSlNktGcnTnt(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpTkSlNktGcnTnt + '/Get?' + queryString);
  }

  exportRpTkSlNktGcnTnt(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpTkSlNktGcnTnt + '/GetExport?' + queryString, { responseType: 'blob' as 'json' });
  }
  getRpStudentHtgd(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpStudentHtgd + '/Get?' + queryString);
  }
  exportRpStudentHtgd(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpStudentHtgd + '/ExportExcel?' + queryString, { responseType: 'blob' as 'json' });
  }
  getRpStudentTtct(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpStudentTtct + '/Get?' + queryString);
  }
  exportRpStudentTtct(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpStudentTtct + '/ExportExcel?' + queryString, { responseType: 'blob' as 'json' });
  }

  geturlRpStudentEducationalStatus(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpStudentEducationalStatus + '/Get?' + queryString);
  }
  exporturlRpStudentEducationalStatus(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpStudentEducationalStatus + '/ExportExcel?' + queryString, { responseType: 'blob' as 'json' });
  }

  getRpStudentTtvl(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpStudentTtvl + '/Get?' + queryString);
  }
  exportRpStudentTtvl(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpStudentTtvl + '/ExportExcel?' + queryString, { responseType: 'blob' as 'json' });
  }

  getRpStudentTthn(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpStudentTthn + '/Get?' + queryString);
  }
  exportRpStudentTthn(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpStudentTthn + '/ExportExcel?' + queryString, { responseType: 'blob' as 'json' });
  }

  geturlBcTDLTkGcnNkt(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcTDLTkGcnNkt + '/Get?' + queryString);
  }
  exporturlBcTDLTkGcnNkt(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcTDLTkGcnNkt + '/GetExport?' + queryString, { responseType: 'blob' as 'json' });
  }

  geturlBcStudentTDLEducationalStatus(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcStudentTDLEducationalStatus + '/Get?' + queryString);
  }
  exporturlBcStudentTDLEducationalStatus(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcStudentTDLEducationalStatus + '/GetExport?' + queryString, { responseType: 'blob' as 'json' });
  }

  geturlBcStudentHtgdTDL(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcStudentHtgdTDL + '/Get?' + queryString);
  }
  exporturlBcStudentHtgdTDL(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcStudentHtgdTDL + '/GetExport?' + queryString, { responseType: 'blob' as 'json' });
  }

  geturlBcStudentTtctTDL(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcStudentTtctTDL + '/Get?' + queryString);
  }
  exporturlBcStudentTtctTDL(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcStudentTtctTDL + '/GetExport?' + queryString, { responseType: 'blob' as 'json' });
  }

  geturlBcStudentTtvlTDL(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcStudentTtvlTDL + '/Get?' + queryString);
  }
  exporturlBcStudentTtvlTDL(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcStudentTtvlTDL + '/GetExport?' + queryString, { responseType: 'blob' as 'json' });
  }

  geturlBcStudentTthnTDL(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcStudentTthnTDL + '/Get?' + queryString);
  }
  exporturlBcStudentTthnTDL(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcStudentTthnTDL + '/GetExport?' + queryString, { responseType: 'blob' as 'json' });
  }

  geturlRpStudentDst(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpStudentDst + '/Get?' + queryString);
  }
  exporturlRpStudentDst(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpStudentDst + '/ExportExcel?' + queryString, { responseType: 'blob' as 'json' });
  }

  geturlBcStudentDkktTDL(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcStudentDkktTDL + '/Get?' + queryString);
  }
  exporturlBcStudentDkktTDL(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcStudentDkktTDL + '/ExportExcel?' + queryString, { responseType: 'blob' as 'json' });
  }

  geturlBcStudentDstTDL(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcStudentDstTDL + '/Get?' + queryString);
  }
  exporturlBcStudentDstTDL(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcStudentDstTDL + '/ExportExcel?' + queryString, { responseType: 'blob' as 'json' });
  }

  geturlRpStudentDkkt(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpStudentDkkt + '/Get?' + queryString);
  }
  exporturlRpStudentDkkt(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpStudentDkkt + '/ExportExcel?' + queryString, { responseType: 'blob' as 'json' });
  }

  geturlRpStudentTcvd(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpStudentTcvd + '/Get?' + queryString);
  }
  exporturlRpStudentTcvd(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpStudentTcvd + '/ExportExcel?' + queryString, { responseType: 'blob' as 'json' });
  }

  geturlRpStudentNt(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpStudentNt + '/Get?' + queryString);
  }
  exporturlRpStudentNt(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlRpStudentNt + '/ExportExcel?' + queryString, { responseType: 'blob' as 'json' });
  }

  geturlBcStudentTlntNkt(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcStudentTlntNkt + '/Get?' + queryString);
  }
  exporturlBcStudentTlntNkt(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcStudentTlntNkt + '/GetExport?' + queryString, { responseType: 'blob' as 'json' });
  }

  geturlBcStudentNngtNkt(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcStudentNngtNkt + '/Get?' + queryString);
  }
  exporturlBcStudentNngtNkt(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcStudentNngtNkt + '/GetExport?' + queryString, { responseType: 'blob' as 'json' });
  }

  geturlBcStudentTlTpvNkt(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcStudentTlTpvNkt + '/Get?' + queryString);
  }
  exporturlBcStudentTlTpvNkt(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcStudentTlTpvNkt + '/GetExport?' + queryString, { responseType: 'blob' as 'json' });
  }

  geturlBcStudentTlHvNkt(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcStudentTlHvNkt + '/Get?' + queryString);
  }
  exporturlBcStudentTlHvNkt(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcStudentTlHvNkt + '/GetExport?' + queryString, { responseType: 'blob' as 'json' });
  }

  geturlBcStudentTcvdTDL(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcStudentTcvdTDL + '/Get?' + queryString);
  }
  exporturlBcStudentTcvdTDL(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcStudentTcvdTDL + '/GetExport?' + queryString, { responseType: 'blob' as 'json' });
  }

  geturlBcStudentTlNcHtGdNkt(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcStudentTlNcHtGdNkt + '/Get?' + queryString);
  }
  exporturlBcStudentTlNcHtGdNkt(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcStudentTlNcHtGdNkt + '/GetExport?' + queryString, { responseType: 'blob' as 'json' });
  }

  geturlBcStudentTlCs(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcStudentTlCs + '/Get?' + queryString);
  }
  exporturlBcStudentTlCs(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcStudentTlCs + '/GetExport?' + queryString, { responseType: 'blob' as 'json' });
  }

  geturlBcStudentGcn(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcStudentGcn + '/Get?' + queryString);
  }
  exporturlBcStudentGcn(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlBcStudentGcn + '/ExportExcel?' + queryString, { responseType: 'blob' as 'json' });
  }

  geturlSchoolADisasibility(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlSchoolADisasibility + '/Get?' + queryString);
  }
  exporturlSchoolADisasibility(filter: any) {
    if (filter.year) {
      const year = new Date(filter.year);
      filter.year = year.getFullYear();
    }
    if (filter.year === null) {
      filter.year = '';
    }
    const queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.urlSchoolADisasibility + '/ExportExcel?' + queryString, { responseType: 'blob' as 'json' });
  }

}
